import { AppSelectBase } from '@/presentation/components';
import React, { useEffect } from 'react';
const AppSelect = ({ name, label, placeholder, required, options, state, setState }) => {
    useEffect(() => {
        if (name === "assignedTeacher") {
            if (state.class.teachers.length > 0) {
                setState(prev => { var _a, _b, _c, _d, _e, _f; return (Object.assign(Object.assign({}, prev), { assignedTeacher: { value: ((_b = (_a = prev.class.teachers) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) ? (_d = (_c = prev.class.teachers) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.id : 0, label: ((_f = (_e = prev.class.teachers) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.firstName) ? `${prev.class.teachers[0].firstName} ${prev.class.teachers[0].lastName}` : '' } })); });
            }
        }
        else if (name === "classGrade") {
            setState(prev => (Object.assign(Object.assign({}, prev), { classGrade: { value: prev.class.grades[0], label: `${prev.class.grades[0]} th` } })));
        }
    }, [name]);
    return (React.createElement(AppSelectBase, { state: state, options: options, setState: setState, name: name, label: label, placeholder: placeholder, required: required }));
};
export default AppSelect;
